import { observer } from 'mobx-react-lite'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import { Paper, Group } from '@mantine/core'
import { AppInput } from '../../../app/common/ui'
import { AppButton } from '@gunslop/ui'
import LoadingComponent from '../../../app/layout/LoadingComponents'
import { useStore } from '../../../app/stores/ardstore'
import { v4 as uuid } from 'uuid'

export default observer(function ArduinoForm () {
  const history = useHistory()
  const { arduinoStore } = useStore()
  const { createArduino, updateArduino, loading, loadArduino, loadingInitial } = arduinoStore
  const { id } = useParams<{ id: string }>()
  const [arduino, setArduino] = useState({ id: '', value: 0 })

  useEffect(() => {
    if (id) { loadArduino(id).then((a) => a && setArduino(a)) }
  }, [id, loadArduino])

  function handleSubmit () {
    if (arduino.id.length === 0) {
      const newArduino = { ...arduino, id: uuid() }
      createArduino(newArduino).then(() => history.push(`/arduinos/${newArduino.id}`))
    } else {
      updateArduino(arduino).then(() => history.push(`/arduinos/${arduino.id}`))
    }
  }

  function handleInputChange (event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target
    setArduino({ ...arduino, [name]: name === 'value' ? Number(value) : value })
  }

  if (loadingInitial) return <LoadingComponent content="Loading arduino..." />

  return (
    <Paper p="md" withBorder>
      <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
        <AppInput placeholder="Value" value={String(arduino.value)} name="value" onChange={handleInputChange} mb="md" />
        <Group position="right">
          <AppButton component={Link} to="/arduinos" variant="default" type="button">Cancel</AppButton>
          <AppButton loading={loading} type="submit">Submit</AppButton>
        </Group>
      </form>
    </Paper>
  )
})
